// Utilities
import { defineStore } from 'pinia'
import API from '@/api/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token    : null,
    user     : null,
    isLoading: false
  }),

  getters: {
    isAuthenticated: state => !!state?.user && !!state.token,
    username       : state => state.user?.username || 'Guest'
  },

  actions: {
    login (username, password, config = {}) {
      this.isLoading = true

      API.endpoint.auth.login(username, password, config)
        .then(response => {
          console.log(response)
        })
        .catch(error => {})
        .finally(() => {
          this.isLoading = false
        })
    },

    logout () {}
  },

  persist: {
    storage: localStorage,
    pick   : undefined,
    omit   : undefined
  }
})
